import { registerItemActive } from './itemActiveRegistry.js';
import {
  canUseConsumableAtHp,
  CONSUMABLE_REFUSE_DEAD,
  CONSUMABLE_REFUSE_FULL_HP,
  CONSUMABLE_REFUSE_HEALING,
  CONSUMABLE_REFUSE_NO_CHARGES,
  CONSUMABLE_REFUSE_ROOTED,
  CONSUMABLE_REFUSE_SILENCED,
  CONSUMABLE_REFUSE_STUNNED,
  ownerHasActiveHealBuff,
  ownerIsRooted,
  ownerIsSilenced,
  ownerIsStunned
} from './consumableStacks.js';

function healFromPotion({ owner, item }) {
  if (owner?.isDead) {
    return { success: false, reason: CONSUMABLE_REFUSE_DEAD };
  }
  if ((item?.stacks ?? 1) <= 0) {
    return { success: false, reason: CONSUMABLE_REFUSE_NO_CHARGES };
  }
  if (ownerIsSilenced(owner)) {
    return { success: false, reason: CONSUMABLE_REFUSE_SILENCED };
  }
  if (ownerIsStunned(owner)) {
    return { success: false, reason: CONSUMABLE_REFUSE_STUNNED };
  }
  if (ownerIsRooted(owner)) {
    return { success: false, reason: CONSUMABLE_REFUSE_ROOTED };
  }
  if (ownerHasActiveHealBuff(owner)) {
    return { success: false, reason: CONSUMABLE_REFUSE_HEALING };
  }
  if (!canUseConsumableAtHp(owner, item)) {
    return { success: false, reason: CONSUMABLE_REFUSE_FULL_HP };
  }
  const amount = item.healAmount || 0;
  if (amount <= 0) return { success: false, reason: 'no_heal' };
  owner.hp = Math.min(owner.maxHp, owner.hp + amount);
  return { success: true, consume: true };
}

function dashWithGaleforce({ owner, item, options = {} }) {
  const range = item.activeDashRange || 450;
  const angle = options.angle ?? owner.facingAngle ?? 0;
  owner.x += Math.sin(angle) * range;
  owner.z += Math.cos(angle) * range;
  owner.targetX = owner.x;
  owner.targetZ = owner.z;
  owner.isMoving = false;
  return {
    success: true,
    consume: false,
    cooldownMs: item.activeCooldownMs || 60000
  };
}

registerItemActive('health_potion', healFromPotion);
registerItemActive('galeforce', dashWithGaleforce);
